import React from "react";

import CloseIcon from "assets/icons/CloseIcon";

const FloatingModal = ({ onClose, isOpen, children }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-40 flex items-center justify-center p-4 bg-black/40 backdrop-blur-sm sm:p-6">
      <div className="relative bg-white rounded-2xl shadow-lg w-full max-w-4xl max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="sticky top-0 z-50 flex justify-end px-4 py-3 bg-white rounded-t-2xl">
          <button
            onClick={onClose}
            className="text-[#E78D41] hover:scale-110 transition"
          >
            <CloseIcon className="w-6 h-6 md:w-8 md:h-8 fill-[#F58220]" />
          </button>
        </div>

        {/* Scrollable Content */}
        <div className="flex-1 px-4 pb-6 overflow-y-auto sm:px-6">
          {children}
        </div>
      </div>
    </div>
  );
};

export default FloatingModal;
